[
  {
    "id": "szkielet-sluga",
    "name": "Szkielet Sługa",
    "health": 18,
    "speed": 55,
    "damage": 8,
    "radius": 13,
    "xp": 1,
    "color": "#d9d2bf",
    "visual": "skeleton-minion",
    "spawnWeight": 10,
    "appearsAt": 0
  },
  {
    "id": "kostny-lotr",
    "name": "Kostny Łotr",
    "health": 30,
    "speed": 75,
    "damage": 10,
    "radius": 12,
    "xp": 2,
    "color": "#9b8f7a",
    "visual": "skeleton-rogue",
    "spawnWeight": 6,
    "appearsAt": 45
  },
  {
    "id": "nieumarly-mag",
    "name": "Nieumarły Mag",
    "health": 22,
    "speed": 70,
    "damage": 9,
    "radius": 11,
    "xp": 2,
    "color": "#9a8fd6",
    "visual": "skeleton-mage",
    "spawnWeight": 4,
    "appearsAt": 90,
    "behavior": "ranged",
    "attack": {
      "range": 260,
      "damage": 4,
      "speed": 220,
      "interval": 3.4,
      "windup": 0.55,
      "fx": "orb"
    }
  },
  {
    "id": "kosciany-kolos",
    "name": "Kościany Kolos",
    "health": 160,
    "speed": 40,
    "damage": 20,
    "radius": 24,
    "xp": 10,
    "color": "#8a7a6a",
    "visual": "skeleton-brute",
    "spawnWeight": 1,
    "appearsAt": 150
  },
  {
    "id": "kostny-strzelec",
    "name": "Kostny Strzelec",
    "health": 20,
    "speed": 60,
    "damage": 6,
    "radius": 12,
    "xp": 2,
    "color": "#c9b98f",
    "visual": "skeleton-archer",
    "spawnWeight": 4,
    "appearsAt": 90,
    "behavior": "ranged",
    "attack": {
      "range": 330,
      "damage": 5,
      "speed": 300,
      "interval": 3.2,
      "windup": 0.6,
      "fx": "bolt",
      "shotRadius": 6
    }
  },
  {
    "id": "plonaca-czaszka",
    "name": "Płonąca Czaszka",
    "health": 12,
    "speed": 95,
    "damage": 4,
    "radius": 12,
    "xp": 2,
    "color": "#ff6a2a",
    "visual": "skeleton-bomber",
    "spawnWeight": 3,
    "appearsAt": 100,
    "behavior": "exploder",
    "attack": {
      "range": 34,
      "damage": 18,
      "interval": 5,
      "windup": 0.65,
      "radius": 70
    }
  },
  {
    "id": "kostny-taran",
    "name": "Kostny Taran",
    "health": 60,
    "speed": 48,
    "damage": 12,
    "radius": 15,
    "xp": 4,
    "color": "#a89a86",
    "visual": "skeleton-charger",
    "spawnWeight": 2,
    "appearsAt": 150,
    "behavior": "charger",
    "attack": {
      "range": 260,
      "damage": 15,
      "speed": 430,
      "interval": 4.5,
      "windup": 0.75
    }
  },
  {
    "id": "krol-kosci",
    "name": "Król Kości",
    "health": 2200,
    "speed": 46,
    "damage": 28,
    "radius": 34,
    "xp": 60,
    "color": "#e8d6a0",
    "visual": "boss-king",
    "spawnWeight": 1,
    "appearsAt": 0,
    "behavior": "boss",
    "attack": {
      "range": 420,
      "damage": 14,
      "speed": 190,
      "interval": 3.4,
      "windup": 0.9,
      "count": 14,
      "shotRadius": 10,
      "fx": "shard"
    },
    "title": "Władca Krypt",
    "boss": {
      "attacks": [
        {
          "kind": "slam",
          "windup": 1.3,
          "damage": 26,
          "radius": 100
        },
        {
          "kind": "ring"
        },
        {
          "kind": "charge",
          "windup": 0.9,
          "damage": 30,
          "length": 380,
          "width": 72
        }
      ],
      "enrage": {
        "at": 0.5,
        "speed": 1.35,
        "interval": 0.75,
        "summon": {
          "enemy": "szkielet-sluga",
          "count": 4,
          "every": 9
        }
      }
    }
  },
  {
    "id": "pradawny-nekromanta",
    "name": "Pradawny Nekromanta",
    "health": 3200,
    "speed": 50,
    "damage": 26,
    "radius": 30,
    "xp": 90,
    "color": "#b58cff",
    "visual": "boss-necro",
    "spawnWeight": 1,
    "appearsAt": 0,
    "behavior": "boss",
    "attack": {
      "range": 440,
      "damage": 15,
      "speed": 210,
      "interval": 3,
      "windup": 0.8,
      "count": 18,
      "shotRadius": 10,
      "fx": "orb"
    },
    "title": "Ten, Który Nie Odszedł",
    "boss": {
      "attacks": [
        {
          "kind": "fan"
        },
        {
          "kind": "slam",
          "windup": 1.2,
          "damage": 22,
          "radius": 90
        },
        {
          "kind": "ring"
        },
        {
          "kind": "slam",
          "windup": 1.2,
          "damage": 22,
          "radius": 90
        }
      ],
      "enrage": {
        "at": 0.5,
        "speed": 1.2,
        "interval": 0.7,
        "summon": {
          "enemy": "nieumarly-mag",
          "count": 3,
          "every": 8
        }
      }
    }
  },
  {
    "id": "oszroniony-wojownik",
    "name": "Oszroniony Wojownik",
    "health": 75,
    "speed": 50,
    "damage": 14,
    "radius": 15,
    "xp": 4,
    "color": "#a8d8ff",
    "visual": "skeleton-frost",
    "spawnWeight": 1,
    "appearsAt": 0
  },
  {
    "id": "mrozny-mag",
    "name": "Mroźny Mag",
    "health": 30,
    "speed": 62,
    "damage": 9,
    "radius": 11,
    "xp": 3,
    "color": "#7fd4ff",
    "visual": "skeleton-frost-mage",
    "spawnWeight": 1,
    "appearsAt": 60,
    "behavior": "ranged",
    "attack": {
      "range": 290,
      "damage": 6,
      "speed": 240,
      "interval": 3.2,
      "windup": 0.6,
      "fx": "shard"
    }
  },
  {
    "id": "lodowy-wladca",
    "name": "Lodowy Władca",
    "health": 3000,
    "speed": 44,
    "damage": 30,
    "radius": 34,
    "xp": 80,
    "color": "#bfe8ff",
    "visual": "boss-frost",
    "spawnWeight": 1,
    "appearsAt": 0,
    "behavior": "boss",
    "attack": {
      "range": 430,
      "damage": 15,
      "speed": 200,
      "interval": 3.2,
      "windup": 0.9,
      "count": 16,
      "shotRadius": 10,
      "fx": "shard"
    },
    "title": "Serce Zimy",
    "boss": {
      "attacks": [
        {
          "kind": "cone",
          "windup": 1.3,
          "damage": 28,
          "radius": 230,
          "arc": 60
        },
        {
          "kind": "ring"
        },
        {
          "kind": "slam",
          "windup": 1.4,
          "damage": 24,
          "radius": 110
        },
        {
          "kind": "charge",
          "windup": 1.0,
          "damage": 28,
          "length": 340,
          "width": 80
        }
      ],
      "enrage": {
        "at": 0.5,
        "speed": 1.3,
        "interval": 0.75,
        "summon": {
          "enemy": "oszroniony-wojownik",
          "count": 3,
          "every": 10
        }
      }
    }
  }
]
